import { ICoreContext } from '@msdyn365-commerce/core';
import React, { useState } from 'react';
import { IOrderDetailResponse } from '../../../actions/order-details/get-order-details.action';
import { ILocalizationState } from '../../../states/localization-state';
import { isMobileView } from '../../../utilities';
import { IOrderDetailsViewProps } from '../order-details';
import { IOrderDetailsResources } from '../order-details.props.autogenerated';
import AddressInformationSection from './address-information-section';
import DocumentsTable from './documents-table';
import GeneralInformationSection from './general-information-section';
import OrderItems from './order-items-table';

interface OrderInformationProps {
    orderDetails: IOrderDetailResponse;
    resources: IOrderDetailsResources;
    context: ICoreContext;
    props: IOrderDetailsViewProps;
    localizationState: ILocalizationState;
}

const OrderInformation: React.FC<OrderInformationProps> = ({ orderDetails, context, resources, props, localizationState }) => {
    const isMobile = isMobileView(context);
    const [isGenInfoCollapsed, setIsGenInfoCollapsed] = useState<boolean>(isMobile);
    const [isAddrInfoCollapsed, setIsAddrInfoCollapsed] = useState<boolean>(isMobile);

    return (
        <>
            <div className='row'>
                <div className='col-12 col-lg-8'>
                    <div className='msc-section-box'>
                        <h3
                            className='msc-section-box__title'
                            onClick={isMobile ? () => setIsGenInfoCollapsed(state => !state) : undefined}
                        >
                            {resources.orderDetailsGeneralInformationSectionHeading}
                        </h3>
                        {!isGenInfoCollapsed && (
                            <div className='msc-section-box__body'>
                                <GeneralInformationSection
                                    context={context}
                                    orderDetails={orderDetails}
                                    resources={resources}
                                    localizationState={localizationState}
                                />
                            </div>
                        )}
                    </div>
                </div>
                <div className='col-12 col-lg-4 address-information'>
                    <div className='msc-section-box'>
                        <h3
                            className='msc-section-box__title'
                            onClick={isMobile ? () => setIsAddrInfoCollapsed(state => !state) : undefined}
                        >
                            {resources?.orderDetailsAddressInformationSectionHeading}
                        </h3>
                        {!isAddrInfoCollapsed && (
                            <div className='msc-section-box__body'>
                                <AddressInformationSection orderDetails={orderDetails} resources={resources} />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <OrderItems
                props={props}
                context={context}
                orderDetails={orderDetails}
                resources={resources}
                localizationState={localizationState}
            ></OrderItems>

            <DocumentsTable
                context={context}
                orderDetails={orderDetails}
                resources={resources}
                localizationState={localizationState}
            ></DocumentsTable>
        </>
    );
};

export default OrderInformation;
